/**
 * @generated SignedSource<<80bc1b7e2fa7a73fd2340c132e681abf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type genericArticleSpeechInlineWidgetGenericArticle$data = {
  readonly entityId: string;
  readonly " $fragmentSpreads": FragmentRefs<"buttonArticleSpeechInlineWidgetGenericButtonArticle" | "hooksShowGenericInlineWidgetByArticleArticle" | "toolTipArticleSpeechWidgetToolTipArticle" | "utilitiesGetHasArticleSpeechArticle">;
  readonly " $fragmentType": "genericArticleSpeechInlineWidgetGenericArticle";
};
export type genericArticleSpeechInlineWidgetGenericArticle$key = {
  readonly " $data"?: genericArticleSpeechInlineWidgetGenericArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"genericArticleSpeechInlineWidgetGenericArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "genericArticleSpeechInlineWidgetGenericArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "buttonArticleSpeechInlineWidgetGenericButtonArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksShowGenericInlineWidgetByArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "toolTipArticleSpeechWidgetToolTipArticle"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "utilitiesGetHasArticleSpeechArticle",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleSpeech",
          "kind": "LinkedField",
          "name": "articleSpeeches",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "3e5c8904fe3cc8bac744a11e3cffa0ee";

export default node;
